import { ReferentialState } from "../types";
import { clearCache, refreshReferentials } from "./async/cacheManagement";
import { fetchReferentialByKey } from "./async/fetchReferentialByKey";
import { initReferentials } from "./async/initReferentials";
import { ReferentialAsyncActions, ReferentialSyncActions } from "./types";

const createAsyncActions = (
  actions: ReferentialSyncActions,
  getState: () => ReferentialState
): ReferentialAsyncActions => {
  return {
    initReferentialsAsync: () => initReferentials(actions),
    fetchReferentialByKeyAsync: (referentialKey) => fetchReferentialByKey(referentialKey, actions),
    clearCacheAsync: () => clearCache(actions),
    refreshReferentialsAsync: () => refreshReferentials(actions)
  }
}

export default createAsyncActions
